import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";

import {
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  CUSTOMER_LIST__ROUTE,
  EMPLOYEES_ROUTE,
  FINANCIAL_ROUTE,
  FORMS_ROUTE,
  FORM_EDIT_ROUTE,
  FORM_SUBMIT_ROUTE,
  DOCUMENTS_ROUTES,
  FRONT_OFFICE_ROUTE,
  INQUIRY_LIST,
  SYSTEM_CONFIGS_ROUTES,
  CANDIDATE_PROFILE_CREATION,
  CANDIDATE_SHORT_LIST,
  LEAD_LIST_ROUTE,
  JOB_ORDER_ROUTE,
  CVDATA_ROUTE,
  CLIENT_ROUTE,
  CANDIDATE_ROUTE,
  CANDIDATE_PROFILE_CREATION_AI,
  CLIENT_HOME_ROUTE,
  REPORTS_ROUTE
} from "./routes";

import DashboardLayout from "./layout/DashboardLayout";
import Dashboard from "./screens/Dashboard";
import CustomerList from "./screens/CustomerList";
import Employees from "./screens/Employees";
import Financial from "./screens/Financial";
import Forms from "./screens/FormsAll";
import FormEdits from "./screens/FormEdits";
import ShortList from "./screens/ShortList";
import Login from "./screens/Login";
import FormSubmit from "./screens/FormSubmit";
import ProfileAi from "./screens/ProfileAi";
import Reports from "./screens/Reports";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { LOGIN_SUCCESS } from "./actions/types";
import { login } from "./actions/auth";
import Documents from "./screens/Documents";
import { getAllCustomers } from "./actions/customers";
import FrontOffice from "./screens/FrontOffice";
import InquiryList from "./screens/InquiryList";
import SystemConfigs from "./screens/SystemConfigs";
import Leads from './apps/leads'
import JobOrders from './apps/jobOrders'
import Cvs from './apps/cv'
import ClientScreen from "./screens/ClientScreen";
import ClientHome from "./screens/ClientHome";
const AppWithRouterAccess = ({ setShowLoading }) => {
  const dispatch = useDispatch();
  const customerList = useSelector((state) => state.customerList);
  const { loading: isDataLoaded, error, customers } = customerList;

  const user = JSON.parse(localStorage.getItem("user"))?.data;
  let history = useHistory();
  useEffect(() => {
    if (user && user?.token && !error) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: user,
      });
      //code before the pause
      setTimeout(function () {
        user?.role === 1 ? history.push(DASHBOARD_ROUTE) : history.push(CANDIDATE_PROFILE_CREATION);
      }, 3000);
    } else {
      history.push(LOGIN_ROUTE);
    }
    //TODO: authorizations
    setShowLoading(false);
  }, []);
  if (user?.role === 1)
    return (
      <Switch>
        <Route exact path={LOGIN_ROUTE}>
          <Login />
        </Route>
        <DashboardLayout>
          <>
            <Route exact path={DASHBOARD_ROUTE}>
              <Dashboard />
            </Route>
            <Route exact path={CUSTOMER_LIST__ROUTE}>
              <CustomerList />
            </Route>
            <Route exact path={EMPLOYEES_ROUTE}>
              <Employees />
            </Route>
            <Route exact path={CANDIDATE_SHORT_LIST}>
            <ShortList />
            </Route> 
            <Route exact path={LEAD_LIST_ROUTE}>
            <Leads />
            </Route>
            <Route exact path={JOB_ORDER_ROUTE}>
            <JobOrders />
            </Route>
            <Route exact path={FINANCIAL_ROUTE}>
              <Financial />
            </Route>
            <Route exact path={CVDATA_ROUTE}>
            <Cvs/>
            </Route>
            <Route exact path={FORMS_ROUTE}>
              <Forms />
            </Route>
            <Route exact path={FRONT_OFFICE_ROUTE}>
              <FrontOffice />
            </Route>
            <Route exact path={INQUIRY_LIST}>
              <InquiryList />
            </Route>
            <Route exact path={CANDIDATE_PROFILE_CREATION}>
              <FormSubmit />
            </Route>
            <Route exact path={CANDIDATE_PROFILE_CREATION_AI}>
              <ProfileAi />
            </Route>
            <Route exact path={FORM_EDIT_ROUTE(1)}>
              <FormEdits />
            </Route>

            <Route exact path={FORM_SUBMIT_ROUTE}>
              <FormSubmit />
            </Route>
            <Route exact path={DOCUMENTS_ROUTES}>
              <Documents />
            </Route>
            <Route exact path={SYSTEM_CONFIGS_ROUTES}>
              <SystemConfigs />
            </Route>
            <Route exact path={REPORTS_ROUTE}>
              <Reports />
            </Route>
          </>
        </DashboardLayout>
      </Switch>
    );
  if(user?.role === 4)
  return (
    <Switch>
      <Route exact path={LOGIN_ROUTE}>
        <Login />
      </Route>
      <DashboardLayout>
        <>
          {/* <Route exact path={DASHBOARD_ROUTE}>
             <Dashboard /> 
          </Route> */}
            <Route exact path={CLIENT_HOME_ROUTE }>
              <ClientHome />
            </Route>
            <Route exact path={JOB_ORDER_ROUTE}>
            <JobOrders />
            </Route>
         

        </>
      </DashboardLayout>
    </Switch>
  );
  if(user?.role===5)
  return(
  <Switch>
      <Route exact path={LOGIN_ROUTE}>
        <Login />
      </Route>
      <DashboardLayout>
        <>
          
          <Route exact path={CANDIDATE_ROUTE}>
             <ClientScreen /> 
          </Route>
          
        </>
      </DashboardLayout>
    </Switch>
  );

  return (
    <Switch>
      <Route exact path={LOGIN_ROUTE}>
        <Login />
      </Route>
      <DashboardLayout>
        <>
          {/* <Route exact path={DASHBOARD_ROUTE}>
             <Dashboard /> 
          </Route> */}
          <Route exact path={CANDIDATE_PROFILE_CREATION}>
            <FormSubmit />
            </Route> 
            <Route exact path={CANDIDATE_PROFILE_CREATION_AI}>
            <ProfileAi />
            </Route>
            <Route exact path={CANDIDATE_SHORT_LIST}>
            <ShortList />
            </Route> 
            <Route exact path={LEAD_LIST_ROUTE}>
            <Leads />
            </Route>
            <Route exact path={JOB_ORDER_ROUTE}>
            <JobOrders />
            </Route>
            <Route exact path={FRONT_OFFICE_ROUTE}>
            <FrontOffice />
            </Route>
            <Route exact path={INQUIRY_LIST}>
              <InquiryList />
            </Route>
            <Route exact path={SYSTEM_CONFIGS_ROUTES}>
            <SystemConfigs />
            </Route>
            <Route exact path={CVDATA_ROUTE}>
            <Cvs/>
            </Route>
            <Route exact path={FORMS_ROUTE}>
              <Forms />
            </Route>
            <Route exact path={REPORTS_ROUTE}>
              <Reports />
            </Route>
        </>
      </DashboardLayout>
    </Switch>
  );
};

export default AppWithRouterAccess;
